module.exports = new __parcel__URL__("whale_select.02fb0ffb.wav").toString();